import {TimelineMax, TweenMax, Sine, Circ, Linear} from 'gsap';
const Snap = require('snapsvg');
const InvalidateUtils = require('./svgAnim/InvalidateUtils');


let params;
let sizeMode;

const _updateParams = function (sizeMode) {
    switch (sizeMode) {
        case 'mobile_landscape':
        case 'mobile_portrait':
            params = {
                width1: 400,
                height1: 400,
                width2: 0,
                height2: 0
            };
            break;

        default:
            params = {
                width1: 768,
                height1: 768,
                width2: 1366,
                height2: 1366
            };
            break;
    }
};

const _updateViewBox = function (d) {
    d.svg1.attr({viewBox: `${-params.width1 / 2} ${-params.height1 / 2} ${params.width1} ${params.height1}`});
    d.svg2.attr({viewBox: `${-params.width2 / 2} ${-params.height2 / 2} ${params.width2} ${params.height2}`});
};


const _updateTotalOpacity = function (d, b) {
    TweenMax.to([d.layerEl1, d.layerEl2], 0.2, {
        delay: 0.25,
        opacity: b ? 1 : 0
    });
};


const init = function () {
    if (this._initiated) return this;


    this.layerEl1 = this.el.querySelector('.js-layer--1');
    this.layerEl2 = this.el.querySelector('.js-layer--2');

    this.svg1 = Snap(100, 100);
    this.svg2 = Snap(100, 100);

    this.layerEl1.appendChild(this.svg1.node);
    this.layerEl2.appendChild(this.svg2.node);

    _updateParams();
    _updateViewBox(this);

    _construct(this);

    _invalidate(this);

    this.el.data = this.el.data || {};
    this.el.data.previewIllustration = this;

    this._initiated = true;

    return this;
};

const _construct = function (diagram) {
    const d = diagram;
    d.c1 = d.svg1.circle(0, 0, 100)
        .attr({
            fill: 'none',
            stroke: '#00a88d',
            strokeWidth: 1.2,
            strokeLinecap: 'round'
        })
        .data({
            visible: true,
            num: 24,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 233 / 2,
            strokeWidth: 1.2
        });

    d.c2 = d.svg1.circle(0, 0, 100)
        .attr({
            fill: 'none',
            opacity: 0.6,
            stroke: '#fff',
            strokeWidth: 1,
            strokeLinecap: 'round'
        })
        .data({
            visible: true,
            num: 206,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 724 / 2,
            strokeWidth: 1
        });

    d.c2M = d.svg1.circle(0, 0, 100)
        .attr({
            fill: 'none',
            opacity: 1,
            stroke: '#fff',
            strokeWidth: 2,
            strokeLinecap: 'round'
        })
        .data({
            visible: false,
            num: 76,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 242 / 2,
            strokeWidth: 2
        });

    d.c3 = d.svg2.circle(0, 0, 100)
        .attr({
            fill: 'none',
            stroke: '#00a88d',
            strokeWidth: 1,
            strokeLinecap: 'round'
        })
        .data({
            visible: true,
            num: 115,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 1138 / 2,
            strokeWidth: 1
        });

    d.dotRotationG = d.svg1.g();
    d.dotDistanceG = d.svg1.g();
    d.dot = d.svg1.circle(0, 0, 5)
        .attr({
            fill: '#ed1c23'
        })
        .data({
            rotation: 85,
            aVelocity: 0
        });
    d.dotRotationG.append(d.dotDistanceG);
    d.dotDistanceG.append(d.dot);
};

const _updateCirclesParams = (d, sizeMode) => {

    switch (sizeMode) {
        case 'mobile_landscape':
        case 'mobile_portrait':
            d.c1.node.style.display = 'none';
            d.c1
                .data({
                    visible: false
                });


            d.c3.node.style.display = 'none';
            d.c3
                .data({
                    visible: false
                });


            d.c2.node.style.display = 'none';
            d.c2
                .data({
                    visible: false
                });


            d.c2M.node.style.display = '';
            d.c2M
                .data({
                    visible: true
                });
            break;

        default:
            d.c1.node.style.display = '';
            d.c1
                .data({
                    visible: true
                });

            d.c3.node.style.display = '';
            d.c3
                .data({
                    visible: true
                });

            d.c2.node.style.display = '';
            d.c2
                .data({
                    visible: true
                });


            d.c2M.node.style.display = 'none';
            d.c2M
                .data({
                    visible: false
                });
            break;
    }


};

const _invalidate = diagram => {
    const d = diagram;
    const t = (new Date()).getTime();
    let b = true;

    if (d.c1.data('visible')) {
        InvalidateUtils.renderDottedCircle(d.c1);
        InvalidateUtils.syncRotation(d.c1, d.c1);

        InvalidateUtils.renderDottedCircle(d.c2);
        InvalidateUtils.syncRotation(d.c2, d.c2);
        d.c2.attr({strokeWidth: d.c2.data('strokeWidth')});

        InvalidateUtils.renderDottedCircle(d.c3);
        InvalidateUtils.syncRotation(d.c3, d.c3);
        d.c3.attr({strokeWidth: d.c3.data('strokeWidth')});
    }


    if (d.c2M.data('visible')) {
        b = false;
        InvalidateUtils.renderDottedCircle(d.c2M);
        InvalidateUtils.syncRotation(d.c2M, d.c2M);
    }

    if (d.lastTime) {
        const av = d.dot.data('aVelocity');
        const sign = av === 0 ? 1 : av / Math.abs(av);
        let rotation = d.dot.data('rotation');
        rotation += av * (t - d.lastTime) / 1000;
        while (rotation * sign > 360)
            rotation -= 360 * sign;
        d.dot.data({
            rotation: rotation
        });
    }
    InvalidateUtils.syncTransformWithRaduis(d.dotDistanceG, b ? d.c2 : d.c2M, 0.25);
    InvalidateUtils.syncRotation(d.dotRotationG, d.dot);

    d.lastTime = t;
}

const show = function () {
    if (!this._initiated) return this;
    if (this._shown) return this;

    const d = this;
    let tl = new TimelineMax({
        delay: 0.15/* ,
        onUpdate: _invalidate,
        onUpdateParams: [this]*/
    });

    tl.to(d.c1.node, 0.1, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st+=' + 1.6);

    tl.to(d.c1.data(), 0.8, {
            r: d.c1.data('R') * 1.05,
            ease: Sine.easeInOut
        }, 'st')
        .to(d.c1.data(), 0.8, {
            r: d.c1.data('R') * 0.9,
            ease: Sine.easeInOut
        }, 'st+=' + 0.8)
        .to(d.c1.data(), 10 * 0.65, {
            r: d.c1.data('R') * 1.05,
            ease: Sine.easeInOut,
            onComplete: () => {
                const tl = new TimelineMax({
                    delay: 0.15,
                    repeat: -1
                });

                tl.to(d.c1.data(), 10 * 0.45, {
                    r: d.c1.data('R') * 0.9,
                    ease: Sine.easeInOut
                }, 'st');

                tl.to(d.c1.data(), 10 * 0.65, {
                    r: d.c1.data('R') * 1.05,
                    ease: Sine.easeInOut
                }, 'st+=' + 10 * 0.45);
            }
        }, 'st');

    tl.to(d.c2.data(), 0.9, {
            r: d.c2.data('R') * 1.05,
            ease: Sine.easeInOut
        }, 'st')
        .to(d.c2.data(), 0.9, {
            r: d.c2.data('R'),
            ease: Sine.easeInOut,
            onComplete: () => {
                const tl = new TimelineMax({
                    delay: 0.15,
                    repeat: -1
                });

                tl.to(d.c2.data(), 10 * 0.45, {
                    r: d.c2.data('R') * 1.04,
                    ease: Sine.easeInOut
                }, 'st');

                tl.to(d.c2.data(), 10 * 0.65, {
                    r: d.c2.data('R'),
                    ease: Sine.easeInOut
                }, 'st+=' + 10 * 0.45);
            }
        }, 'st+=' + 0.9);


    tl.to(d.c2.node, 0.1, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(d.c2M.data(), 0.9, {
            r: d.c2M.data('R') * 1.05,
            ease: Sine.easeInOut
        }, 'st')
        .to(d.c2M.data(), 0.9, {
            r: d.c2M.data('R'),
            ease: Sine.easeInOut,
            onComplete: () => {
                const tl = new TimelineMax({
                    delay: 0.15,
                    repeat: -1
                });

                tl.to(d.c2M.data(), 10 * 0.45, {
                    r: d.c2M.data('R') * 1.04,
                    ease: Sine.easeInOut
                }, 'st');

                tl.to(d.c2M.data(), 10 * 0.65, {
                    r: d.c2M.data('R'),
                    ease: Sine.easeInOut
                }, 'st+=' + 10 * 0.45);
            }
        }, 'st+=' + 0.9);

    tl.to(d.c2M.node, 0.1, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(d.c3.data(), 0.5, {
            r: d.c3.data('R') * 0.75,
            ease: Sine.easeIn
        }, 'st')
        .to(d.c3.data(), 1.2, {
            r: d.c3.data('R'),
            ease: Circ.easeOut
        }, 'st+=' + 0.5);

    tl.to(d.c3.node, 0.2, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(d.dot.data(), 1.5, {
            aVelocity: 865,
            ease: Sine.easeOut
        }, 'st')
        .to(d.dot.data(), 1.7, {
            aVelocity: 3,
            ease: Sine.easeInOut
        }, 'st+=' + 0.6);

    tl.to(d.dot.node, 0.2, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    this._tl = tl;


    // LOOP
    this._loopTLs = [];
    tl = new TimelineMax({
        delay: 0.15,
        repeat: -1,
        onUpdate: _invalidate,
        onUpdateParams: [this]
    });
    this._loopTLs.push(tl);

    tl.to(d.c2.data(), 126, {
        rotation: -360,
        ease: Linear.easeInOut
    }, 'st');

    tl.to(d.c2M.data(), 126, {
        rotation: -360,
        ease: Linear.easeInOut
    }, 'st');


    tl = new TimelineMax({
        delay: 0.15,
        repeat: -1
    });
    this._loopTLs.push(tl);

    tl.to(d.c1.data(), 92, {
        rotation: 360,
        ease: Linear.easeInOut
    });

    tl = new TimelineMax({
        delay: 0.15,
        repeat: -1
    });
    this._loopTLs.push(tl);

    tl.to(d.c3.data(), 192, {
        rotation: 360,
        ease: Linear.easeInOut
    });

    this._shown = true;

    return this;
};

const hide = function (destroy) {
    if (!this._initiated) return this;
    if (!this._shown) return this;

    const d = this;
    const tl = new TimelineMax({
        delay: 0.15
        /* ,
         onUpdate: _invalidate,
         onUpdateParams: [this]*/
    });

    this._tl.kill();
    _killTLs(this._loopTLs2);

    tl.to(d.c2.data(), 0.45, {
        r: 5,
        ease: Sine.easeIn
    }, 'st');

    tl.to(d.c3.data(), 0.45, {
        r: 10,
        ease: Sine.easeIn
    }, 'st');



    tl.to(d.c1.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    tl.to(d.c2.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    tl.to(d.c3.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    tl.to(d.dot.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    this._shown = false;

    if (destroy) {
        setTimeout(() => {
            this.destroy();
        }, 1000);
    }

    return this;
};

const destroy = function () {
    if (!this._initiated) return this;

    this._tl.kill();
    _killTLs(this._loopTLs);
    _killTLs(this._loopTLs2);

    this._initiated = false;
    this._shown = false;
    return this;
};

const _resize = function (sizeModeValue) {
    if (!this._initiated) return this;

    sizeMode = sizeModeValue;

    _updateParams(sizeMode);
    _updateViewBox(this);
    _updateCirclesParams(this, sizeMode);

    if (this._isCover)
        _updateTotalOpacity(this, !(sizeMode === 'mobile_landscape' || sizeMode === 'mobile_portrait'));

    _invalidate(this);

    return this;
};

const gotoCover = function () {
    if (!this._initiated) return this;

    this._loopTLs2 = [];

    const d = this;
    d._isCover = true;

    const tl = new TimelineMax({
        delay: 0.15
        /* ,
         onUpdate: _invalidate,
         onUpdateParams: [this]*/
    });

    // DESKTOP:
    tl.to(d.c3.data(), 0.7, {
        strokeWidth: 3,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(d.c1.data(), 0.5, {
        r: d.c1.data('R') * 0.8,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(d.c1.data(), 0.5, {
        r: d.c3.data('R') * 0.7,
        ease: Sine.easeIn
    }, 'st+=' + 0.5);

    tl.to(d.c1.node, 0.25, {
        opacity: 0,
        ease: Sine.easeIn
    }, 'st+=' + 0.75);

    tl.to(d.c2.node, 0.7, {
        opacity: 1,
        ease: Sine.easeInOut
    }, 'st');

    tl.to(d.c2.data(), 0.7, {
            r: d.c2.data('R') * 1.05,
            strokeWidth: 1.5,
            ease: Sine.easeInOut
        }, 'st')
        .to(d.c2.data(), 1.7, {
            r: d.c2.data('R'),
            ease: Sine.easeInOut,
            onComplete: () => {
                const tl = new TimelineMax({
                    delay: 0.15,
                    repeat: -1
                });

                tl.set(d.c2.data(), {
                    r: d.c2.data('R')
                }, 'st');

                tl.to(d.c2.data(), 10 * 0.45, {
                    r: d.c2.data('R') * 1.05,
                    ease: Sine.easeInOut
                }, 'st');

                tl.to(d.c2.data(), 10 * 0.65, {
                    r: d.c2.data('R'),
                    ease: Sine.easeInOut
                }, 'st+=' + 10 * 0.45);

                this._loopTLs2.push(tl);
            }
        }, 'st+=' + 0.9);

    tl.to(d.c3.data(), 0.9, {
            r: d.c3.data('R') * 1.02,
            ease: Sine.easeInOut
        }, 'st')
        .to(d.c3.data(), 1.9, {
            r: d.c3.data('R') * 0.98,
            ease: Sine.easeInOut,
            onComplete: () => {
                const tl = new TimelineMax({
                    delay: 0.15,
                    repeat: -1
                });

                tl.set(d.c3.data(), {
                    r: d.c3.data('R') * 0.98
                }, 'st');

                tl.to(d.c3.data(), 10 * 0.45, {
                    r: d.c3.data('R') * 1.03,
                    ease: Sine.easeInOut
                }, 'st');

                tl.to(d.c3.data(), 10 * 0.65, {
                    r: d.c3.data('R') * 0.98,
                    ease: Sine.easeInOut
                }, 'st+=' + 10 * 0.45);

                this._loopTLs2.push(tl);
            }
        }, 'st+=' + 0.9);

    tl.to(d.dot.data(), 1.5, {
        aVelocity: 250,
        ease: Sine.easeOut
    }, 'st')
        .to(d.dot.data(), 1.7, {
            aVelocity: 3,
            ease: Sine.easeInOut
        }, 'st+=' + 0.6);


    // MOBILE:

    tl.to(d.c2M.data(), 0.45, {
        r: 5,
        ease: Sine.easeIn
    }, 'st');

    tl.to(d.c2M.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    tl.to(d.c2.data(), 0.45, {
        r: 5,
        ease: Sine.easeIn
    }, 'st');

    tl.to(d.c3.data(), 0.45, {
        r: 10,
        ease: Sine.easeIn
    }, 'st');



    tl.to(d.c1.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    tl.to(d.c2.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    tl.to(d.c3.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    tl.to(d.dot.node, 0.2, {
        opacity: 0,
        ease: Sine.easeInOut
    }, 'st+=' + 0.25);

    this._shown = false;

    if (destroy) {
        setTimeout(() => {
            this.destroy();
        }, 1000);
    }

    // sfdsfsdfs

    tl.to(
        d.c2.data(),
        0.45,
        {
            r: 5,
            ease: Sine.easeIn
        },
        'sto'
    );

    tl.to(
        d.c3.data(),
        0.45,
        {
            r: 10,
            ease: Sine.easeIn
        },
        'sto'
    );

    tl.to(
        d.c1.node,
        0.2,
        {
            opacity: 0,
            ease: Sine.easeInOut
        },
        'sto+=' + 0.25
    );

    tl.to(
        d.c2.node,
        0.2,
        {
            opacity: 0,
            ease: Sine.easeInOut
        },
        'sto+=' + 0.25
    );

    tl.to(
        d.c3.node,
        0.2,
        {
            opacity: 0,
            ease: Sine.easeInOut
        },
        'sto+=' + 0.25
    );

    tl.to(
        d.dot.node,
        0.2,
        {
            opacity: 0,
            ease: Sine.easeInOut
        },
        'sto+=' + 0.25
    );

    this._shown = false;

    setTimeout(() => {
        this.destroy();
    }, 3000);

    this._tl = tl;

    if (sizeMode === 'mobile_landscape' || sizeMode === 'mobile_portrait') {
        TweenMax.to([this.layerEl1, this.layerEl2], 0.2, {
            delay: 0.25,
            opacity: 0
        });
    }


    return this;
};

const _killTLs = arr => {
    arr.forEach(tl => {
        tl.kill();
    })
};


module.exports = el => {

    if (el.data && el.data.previewIllustration) return el.data.previewIllustration;

    const Diagram = {
        el: el
    };

    Diagram.init = init.bind(Diagram);
    Diagram.show = show.bind(Diagram);
    Diagram.hide = hide.bind(Diagram);
    Diagram.resize = _resize.bind(Diagram);
    Diagram.destroy = destroy.bind(Diagram);
    Diagram.gotoCover = gotoCover.bind(Diagram);

    return Diagram;
}



// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/PreviewIllustration.js